import {
  IonAvatar,
  IonButton,
  IonHeader,
  IonIcon,
  IonImg,
  IonModal,
  IonRow,
} from "@ionic/react";
import * as d3 from "d3";
import { arrowForward, checkmarkCircleOutline, close } from "ionicons/icons";
import ZoomSvg from "../../assets/svg/zoom.svg";
import { ReactSVG } from "react-svg";

import "./VehicleWithDamages.css";

interface VehicleWithDamagesProps {
  elementSvg: string;
  damageList: {
    id: string;
    number: number;
    type: string;
    label: string;
    damageId?: string;
    picture?: string;
  }[];
  setDamageModalIsOpen: (value: boolean) => void;
  setSelectedDamage: (value: string) => void;
}

const VehicleWithDamages: React.FC<VehicleWithDamagesProps> = ({
  elementSvg,
  damageList,
  setDamageModalIsOpen,
  setSelectedDamage,
}) => {
  return (
    <ReactSVG
      className={`VehicleWithDamages-tractor ${"VehicleWithDamages-tractor_resize"}`}
      src={elementSvg}
      afterInjection={(svg) => {
        const svgEl = svg as SVGSVGElement;
        const viewBox = svgEl.viewBox.baseVal;

        const scaleRatio = viewBox.width / svgEl.clientWidth;
        const circleRadius = 15 * scaleRatio;

        requestAnimationFrame(() => {
          d3.select(svg as SVGSVGElement)
            .selectAll("path")
            .each(function () {
              const ctx = this as SVGSVGElement;
              const elementId = ctx?.id.split("-")[0];
              if (!elementId) return;

              if (damageList.some((el) => el.id === elementId)) {
                let damage = damageList.find((el) => el.id === elementId);

                const node = d3.select(this).node();

                const bbox = (node as any)?.getBBox();

                if (bbox.x === 0) return;

                const centerX = bbox.x + bbox.width / 2;
                const centerY = bbox.y + bbox.height / 2;

                const svgGlobal = d3.select(svg);
                const group = svgGlobal
                  .append("g")
                  .attr("transform", `translate(${centerX}, ${centerY})`);

                group
                  .append("circle")
                  .attr("r", circleRadius)
                  .attr("fill", damage?.damageId ? "red" : "yellow")
                  .attr("stroke", "black");
                group
                  .append("text")
                  .attr("text-anchor", "middle")
                  .attr("dy", "0.35em")
                  .style("fill", damage?.damageId ? "white" : "black")
                  .style("font-size", `${circleRadius}px`)
                  .text(
                    damage?.id === "cabine" ||
                      damage?.id === "carrierTrailerInside" ||
                      damage?.id === "trailerInside"
                      ? "!"
                      : damage?.number.toString() || ""
                  )
                  .on("click", () => {
                    setSelectedDamage(
                      damage?.damageId ||
                        `${damage?.number}-${damage?.damageId}` ||
                        ""
                    );
                    setDamageModalIsOpen(true);
                  });
              }
            });
        });
      }}
    />
  );
};

export default VehicleWithDamages;
